/**
 * @name Captable Action
 * @memberof module:common/actions
 * @type {ReduxAction}
 * @return {Object} Global Actions
 */
// #region contant
import { MeasurementDate } from 'api/models/MeasurementDate';
import { Fund } from 'common/types/fund';
import { FundService } from 'services';
import { SET_CURRENT_MP_BY_FUND, SET_FUND_INFO, SET_FUND_LIST } from './types';
// #endregion

const fundService = new FundService();

/**
 * @function
 * @name setFundInfo
 * @description set firm data selected.
 * @param {object | null} fundInfo  - fund name
 * @return {object} Action context
 */

export const setFundInfo = (fundInfo: Fund | null) => ({
  type: SET_FUND_INFO,
  fundInfo,
});

// Fund[] | null
export const setFundList = (fundList: Fund[] | null) => ({
  type: SET_FUND_LIST,
  fundList,
});

// MeasurementDate
export const setMeasurementDateByFund = (currentMeasurementDateByFund: MeasurementDate) => ({
  type: SET_CURRENT_MP_BY_FUND,
  currentMeasurementDateByFund,
});

// string / string
export const getFundSummaryInfo = async (fundId: string, mdId: string) => {
  try {
    return await fundService.getFundSummaryByMD(fundId, mdId);
  } catch (error) {
    return error;
  }
};

// string
export const getFundById = async (fundId: number) => {
  try {
    return fundService.getFundById(fundId);
  } catch (error) {
    return error;
  }
};
